import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { aboutApi } from "./api";
import type { AboutPageInput } from "./types";

export const aboutKeys = {
  detail: ["about-page"] as const,
};

export function useAboutPage() {
  return useQuery({
    queryKey: aboutKeys.detail,
    queryFn: aboutApi.get,
  });
}

export function useUpdateAboutPage() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: AboutPageInput) => aboutApi.update(input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: aboutKeys.detail }),
  });
}
